import {Button, Card, Col, Divider, Form, message, Modal, Row, Space, Spin, Statistic, Typography} from "antd";
import {
    CalendarOutlined,
    ClockCircleOutlined,
    DownloadOutlined,
    ExclamationCircleOutlined,
    EyeOutlined,
    LinkOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import {
    CHANGE_REQUEST_RECORD_STATUS,
    DOC_CODE_SIGNATURE_DOC,
    DOC_CODE_SIGNATURE_DOC_TEMP,
    PREVIEW_DOC_TYPES
} from "../../../util/Constants";
import {useEffect, useState} from "react";
import ChangeRequestHistoryTableComp from "./changeRequestHistoryTableComp";
import customerChangeRequestService from "../../../service/customerChangeRequestService";
import {
    MSG_BANK_DETAIL_CHANGE_HISTORY_LIST_FETCH_FAILURE_ERROR,
    MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR,
    MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR
} from "../../../util/Messages";
import ErrorHandler from "../../../util/ErrorHandler";
import {SignatureDto} from "../../../dto/SignatureDto";
import {UploadedDocumentDetailDto} from "../../../dto/UploadedDocumentDetailDto";
import documentService from "../../../service/documentService";
import {DefaultDocumentDto} from "../../../dto/DefaultDocumentDto";
import PreviewModalComp from "../../common/preview/PreviewModalComp";
import TextArea from "antd/es/input/TextArea";
import modal from "antd/es/modal";

const {Paragraph} = Typography;

interface SignatureDetailHistoryProps {
    cin: string
    handleTabChange: (activeKey: string) => void
}

const SignatureChangeRequestHistoryComp = (props: SignatureDetailHistoryProps) => {
    const [isLoading, setLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [docURL, setDocURL] = useState('');
    const [previewOpen, setPreviewOpen] = useState(false);
    const [scheduledEndTime, setScheduledEndTime] = useState('');
    const [scheduledStartTime, setScheduledStartTime] = useState('');
    const [videoLink, setVideoLink] = useState('');
    const [scheduledDate, setScheduledDate] = useState('');
    const [previewTitle, setPreviewTitle] = useState('');
    const [docType, setDocType] = useState<PREVIEW_DOC_TYPES>(PREVIEW_DOC_TYPES.IMAGE);
    const [signatureDetailHistoryList, setSignatureDetailHistoryList] = useState<SignatureDto[]>()
    const [signatureUploadedList, setSignatureUploadedList] = useState<DefaultDocumentDto[]>()
    const [signatureForm] = Form.useForm()
    const [correspondentAddressForm] = Form.useForm();
    const [isShowRejectReason, setCanShowRejectReason] = useState<boolean>(false)
    const [rejectReasonForm] = Form.useForm()
    const [isShowCancelRequest, setShowCancelRequest] = useState<boolean>(false)
    const [selectedCin, setSelectedCin] = useState("");


    useEffect(() => {
        fetchSignatureChangeRequestHistory(props.cin)
    }, []);

    const fetchSignatureChangeRequestHistory = (cin: string) => {
        setLoading(true)
        customerChangeRequestService.getCustomerSignatureDetailHistory(cin).then((res) => {
            if (res.data.results) {
                setSignatureDetailHistoryList(res.data.results)
                setLoading(false)
            } else {
                message.error(MSG_BANK_DETAIL_CHANGE_HISTORY_LIST_FETCH_FAILURE_ERROR)
                setLoading(false)
            }
        }).catch(reason => {
            ErrorHandler.handleError(reason)
            setLoading(false)
        })
    }


    const handleCancel = () => {
        setIsModalOpen(false);
        // signatureForm.resetFields()
        setScheduledDate("")
        setScheduledStartTime("")
        setScheduledEndTime("")
        setSignatureUploadedList([])
    };

    const onCancelRequest = () => {
        setLoading(true)
        modal.confirm({
            title: 'Confirm',
            className: 'confirm-dialog-box',
            icon: <ExclamationCircleOutlined/>,
            content: `Are you sure?, Do you want to cancel this signature change request?`,
            okText: 'Yes',
            cancelText: 'No',
            okButtonProps: {style: {background: '#FF7400'}},
            onOk() {
                customerChangeRequestService.cancelCustomerSignatureChangeRequest(selectedCin).then(res => {
                    if (res.data !== null && res.data.results) {
                        message.success("Signature change request cancelled successfully").then();
                        handleCancel()
                        setLoading(false)
                        props.handleTabChange("1")
                    } else {
                        message.error("Signature change request cancel failure").then();
                        setLoading(false)
                    }
                }, (reason) => {
                    ErrorHandler.handleError(reason);
                    setLoading(false)
                })
            },
            onCancel() {
                setLoading(false)
            }
        });
    }

    const showModalHst = (record: SignatureDto) => {
        setIsModalOpen(true)
        setScheduledDate(record.requestedDate)
        setScheduledStartTime(record.requestedStartTime)
        setScheduledEndTime(record.requestedEndTime)
        setVideoLink(record.videoLink)
        setSelectedCin(record.cin)
        setShowCancelRequest(CHANGE_REQUEST_RECORD_STATUS.SUBMITTED == record.recordStatus)
        loadUploadedDocumentsById(record.jobNumber, record.signatureDocId,
            [record.recordStatus === "ACCEPTED" ?
                DOC_CODE_SIGNATURE_DOC : DOC_CODE_SIGNATURE_DOC_TEMP])
        if (null != record.rejectReason) {
            setCanShowRejectReason(true)
            rejectReasonForm.setFieldsValue({rejectReason: record.rejectReason})
        } else {
            setCanShowRejectReason(false)
            rejectReasonForm.resetFields()
        }

    }
    const loadUploadedDocumentsById = (jobNo: number, docId: number, docTypeCode: string[]) => {
        documentService.getUploadDocumentListByTypeAndUploadedDocId(jobNo, docId, docTypeCode).then(res => {
            if (res.data !== null) {
                createUploadedDocuments(res.data.results[0].uploadDocumentDetailDto, res.data.results[0].documentTypeId)
            } else {
                message.error(MSG_FAILED_TO_FETCH_AGREEMENTS_ERROR).then();
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        });
    };
    const createUploadedDocuments = (uploadDocumentDetailDtoList: UploadedDocumentDetailDto, documentTypeId: number) => {
        let defaultFileList;
        if (undefined != uploadDocumentDetailDtoList) {
            defaultFileList =
                [{
                    uid: uploadDocumentDetailDtoList.uploadDocumentDetailId.toString(),
                    name: uploadDocumentDetailDtoList.originalDocumentName,
                    thumbUrl: uploadDocumentDetailDtoList.thumbB64,
                    url: uploadDocumentDetailDtoList.thumbDocumentPath
                }]
        } else {
            defaultFileList = undefined;
        }

        setSignatureUploadedList(defaultFileList)

    }
    const openModal = (documentId: string, docTypeName: string) => {
        setLoading(true)
        documentService.viewOriginalDocument(documentId).then(res => {
            if (res.data !== null) {
                setPreviewOpen(true)
                setIsModalOpen(false)
                setPreviewTitle(docTypeName);
                setDocURL(res.data.results)
                setDocType(checkDocumentContentType(res.data.results))
                setLoading(false)
            } else {
                message.error(MSG_FAILED_TO_FETCH_DOCUMENTS_ERROR).then();
                setLoading(false)
            }
        }, (reason) => {
            setLoading(false)
            ErrorHandler.handleError(reason);
        })
        return true;
    };
    const checkDocumentContentType = (base64: string): PREVIEW_DOC_TYPES => {

        if (base64.includes("image/png") || base64.includes("image/jpeg") || base64.includes("image/jpg")) {
            return PREVIEW_DOC_TYPES.IMAGE;
        } else {
            return PREVIEW_DOC_TYPES.PDF;
        }

    };
    const handlePreviewCancel = () => {
        setPreviewOpen(false);
        setDocURL('')
    };
    const download = (val: string, docName: string) => {
        let a = document.createElement('a');
        a.href = val;
        a.download = docName;
        a.click();
    }
    return (
        <>
            <Row gutter={[24, 12]}>

                <Col span={24}>
                    <ChangeRequestHistoryTableComp tableData={signatureDetailHistoryList}
                                                   onShowModal={showModalHst}
                                                   loading={isLoading}/>
                </Col>
            </Row>
            <Modal title="Signature Change Request"
                   open={isModalOpen}
                   footer={null}
                   onCancel={handleCancel}
                   width={800}
                   centered
                   style={{top: 20, paddingBottom: 20}}
                   destroyOnClose={true}>
                <Row gutter={[24, 12]} className={'form-item-mb-12'} style={{marginTop: 18}}>
                    <Col span={24}>
                        <Card title="Request Details" size={'small'}>
                            <Form
                                className='form-input'
                                layout={"vertical"}
                                form={signatureForm}
                            >
                                <Spin spinning={isLoading}>
                                    <Row gutter={[12, 0]}>
                                        <Col span={24}>
                                            <Form.Item
                                                label="Signature"
                                                name={"signature"}

                                            >
                                                <div className='utility_bill img-nic'
                                                     style={{width: '96%'}}>
                                                    <div className='utulity_bill_icon_div'>
                                                        <div className="img_div">
                                                            <img
                                                                src={signatureUploadedList && signatureUploadedList.length ? signatureUploadedList[0].thumbUrl : ''}
                                                                alt=""/>
                                                        </div>
                                                        <div className='name_div'>
                                                            <h5>{signatureUploadedList && signatureUploadedList.length ? signatureUploadedList[0].name : ''}</h5>
                                                        </div>
                                                    </div>
                                                    <Button
                                                        onClick={() => openModal(
                                                            signatureUploadedList ? signatureUploadedList[0].uid : '',
                                                            signatureUploadedList ? signatureUploadedList[0].name : '')}
                                                        className='doc-view-btn'><EyeOutlined/>
                                                    </Button>
                                                </div>
                                            </Form.Item>
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <div className="sign-meeting-sch-date-time-info">
                                                <div className="sch-date-info">
                                                    <Statistic title="Scheduled Date"
                                                               value={dayjs(scheduledDate).format("dddd, MMM DD")}
                                                               prefix={<CalendarOutlined/>}/>
                                                </div>
                                                <div className="sch-time-info">
                                                    <Statistic title="Start Time" value={scheduledStartTime}
                                                               prefix={<ClockCircleOutlined/>}/>
                                                </div>
                                                <div className="sch-time-info">
                                                    <Statistic title="End Time" value={scheduledEndTime}
                                                               prefix={<ClockCircleOutlined/>}/>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                                            <div className="sign-meeting-sch-date-time-info meeting-link">
                                                <div>
                                                    <Statistic title="Meeting Link"
                                                               value={videoLink ?? "N/A"}
                                                               prefix={
                                                                   <LinkOutlined/>}
                                                               suffix={<Paragraph
                                                                   copyable={{text: videoLink ?? ""}}></Paragraph>}

                                                    />

                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Spin>

                            </Form>
                        </Card>
                    </Col>
                    {isShowRejectReason ?
                        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <Divider></Divider>

                            <Form form={rejectReasonForm}
                                  className='form-input'
                                  layout={"vertical"}
                                  form={rejectReasonForm}
                            >
                                <Form.Item

                                    name={"rejectReason"}
                                    label={"Reject Reason"}>
                                    <TextArea disabled bordered={true}/>
                                </Form.Item>
                            </Form>
                        </Col>
                        :
                        <></>
                    }
                    <Col span={24}>
                        <Divider style={{marginBottom: 12}}></Divider>
                    </Col>
                    <Col span={24}>
                        <Space style={{float: 'right'}}>
                            {isShowCancelRequest ?
                                <Button
                                    onClick={onCancelRequest}>Cancel Request</Button>
                                :
                                <Button onClick={handleCancel}
                                     style={{
                                         width: 80
                                     }}>Cancel</Button> }
                        </Space>
                    </Col>
                </Row>

            </Modal>

            <Modal
                className={docType == PREVIEW_DOC_TYPES.PDF ? "modal-custom-bg" : "image-view-modal"}
                open={previewOpen}
                centered
                title={previewTitle}
                onCancel={handlePreviewCancel}
                destroyOnClose={true}
                width={docType == PREVIEW_DOC_TYPES.PDF ? 800 : 600}
                footer={[
                    <Button type="primary" icon={<DownloadOutlined/>} style={{background: '#FF7400', height: 40}}
                            htmlType="submit" onClick={() => download(docURL, previewTitle)}>
                        Download
                    </Button>]}>
                <PreviewModalComp docURL={docURL}/>
            </Modal>
        </>
    )
}
export default SignatureChangeRequestHistoryComp;